import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT,
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_SUCCESS,
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_ERROR,
} from "./constant";

import { getAzureDBPerformanceInsightApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */

function* getAzureDatabasePerformanceInsightList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureDBPerformanceInsightApi, params, provider);

    yield put({ type: GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureDatabasePerformanceInsightSaga() {
  yield takeLatest(
    GET_AZURE_DATABASE_PERFORMANCE_INSIGHT,
    getAzureDatabasePerformanceInsightList
  );
}
